/**
 * Models
 *
 * Translate back-end service fields into local names for consistency.
 * If the API changes in future, the models only needs to update the mapping, and don't need to update everywhere else, i.e. in the views.
 *
 * You can/should also include any helper/data-updating functions on the models and not on the views/controller components.
 */
const ModelObjectSeparator = ".";
class BaseModel {
	constructor(dataMap = {}, defaultValues = {}) {
		this.type = "";
		this.dataMap = dataMap;
		this.data = {};
		this.defaults = defaultValues;
	}

	setData(data) {
		this.data = data;
	}

	set(key, val) {
		this.data[key] = val;
	}

	get(key) {
		const result = BaseModel.getMapResult(key, this.data, this.dataMap);
		if (!result) {
			return BaseModel.getMapResult(key, this.defaults, {});
		}
		return result;
	}
}
BaseModel.getMapResult = (key, obj, objMap) => {
	// console.log("getMapResult", key, obj, objMap);

	const mappedFrom = objMap[key];
	const mappedFromType = typeof objMap[key];

	let result;
	if (mappedFromType === "undefined") {
		result = obj[key];
	}
	else {
		result = obj[mappedFrom];
	}
	if (mappedFrom) {
		const dot = mappedFrom.indexOf(ModelObjectSeparator);
		if (dot >= 0) {
			const left = mappedFrom.substr(0, dot);
			const right = mappedFrom.substr(dot + 1);
			return BaseModel.getMapResult(right, obj[left], {});
		}
	}
	return result;
};
BaseModel.noMapping = (data) => {
	const mapping = {};
	Object.keys(data).forEach((item) => {
		mapping[item] = item;
	});
	return mapping;
};

// For Vessels, we receive different property names/keys in Alerts data and in data from Spire.
// This is how we map both property types into one Vessel object.
// e.g. We might remap Course to course (VesselProperty.COURSE from VesselAlertDataPropertyMap.COURSE).
// This was previously done by extending the BaseModel, but somebody removed it. :eyes: :sob:
BaseModel.remap = (feature, inputData, baseMap, inputMap) => {
	const propertyKeys = Object.keys(baseMap);
	for (const index in propertyKeys) {
		const key = baseMap[propertyKeys[index]];
		if (typeof inputMap[key] !== "undefined" && typeof inputData.properties[inputMap[key]] !== "undefined") {
			feature.properties[key] = inputData.properties[inputMap[key]];
		}
	}
};
export default BaseModel;
